import { render, staticRenderFns } from "./LihatRekomendasi.vue?vue&type=template&id=33fb1eaa"
import script from "./LihatRekomendasi.vue?vue&type=script&lang=js"
export * from "./LihatRekomendasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports